import { render, staticRenderFns } from "./ClientsDropDownList.vue?vue&type=template&id=2c1462b5"
import script from "./ClientsDropDownList.vue?vue&type=script&lang=js"
export * from "./ClientsDropDownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports